export interface AiChatSuggestion {
  title: string;
  message: string;
  partial?: boolean;
  className?: string;
}
